import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()(() => {
    return {
        table: {
            maxHeight: 400,
        },
    }
})

export default useStyles
